import { createSvgIcon } from '@mui/material';
import React from 'react';

export const ComedyMask = createSvgIcon(
    <>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_comedy_mask)">
                <rect width="24" height="24" fill="none" />
                <path
                    d="M15.2875 11.975L16 8.9L13.6125 6.825L16.7625 6.55L18 3.6375L19.2375 6.55L22.3875 6.825L20 8.9L20.7125 11.975L18 10.35L15.2875 11.975Z"
                    fill="currentColor"
                />
                <path
                    d="M7 18.4667C7.74444 18.4667 8.37222 18.2111 8.88333 17.7C9.39445 17.1778 9.65 16.55 9.65 15.8167H4.35C4.35 16.55 4.60556 17.1778 5.11667 17.7C5.62778 18.2111 6.25556 18.4667 7 18.4667ZM3.53333 12.9667H6.38333C6.38333 12.5667 6.23889 12.2333 5.95 11.9667C5.67222 11.6889 5.33889 11.55 4.95 11.55C4.56111 11.55 4.22778 11.6889 3.95 11.9667C3.67222 12.2333 3.53333 12.5667 3.53333 12.9667ZM7.61667 12.9667H10.4667C10.4667 12.5667 10.3222 12.2333 10.0333 11.9667C9.75556 11.6889 9.42222 11.55 9.03333 11.55C8.64445 11.55 8.31111 11.6889 8.03333 11.9667C7.75556 12.2333 7.61667 12.9667 7.61667 12.9667ZM7 21.7167C6.17778 21.7167 5.40556 21.5611 4.68333 21.25C3.97222 20.9389 3.35 20.5222 2.81667 20C2.28333 19.4667 1.86111 18.8389 1.55 18.1167C1.23889 17.3944 1.08333 16.6278 1.08333 15.8167V8.28333H12.9167V15.8167C12.9167 16.6278 12.7611 17.3944 12.45 18.1167C12.1389 18.8389 11.7167 19.4667 11.1833 20C10.65 20.5222 10.0222 20.9389 9.3 21.25C8.57778 21.5611 7.81111 21.7167 7 21.7167ZM7 20.0833C8.18889 20.0833 9.2 19.6722 10.0333 18.85C10.8667 18.0167 11.2833 17 11.2833 15.8V9.91667H2.71667V15.8C2.71667 16.9889 3.13333 18 3.96667 18.8333C4.8 19.6667 5.81111 20.0833 7 20.0833Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_comedy_mask">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    </>,
    'ComedyMask'
);

